import { loadStripe } from "@stripe/stripe-js/pure"

let stripePromise
export const loadStripeInstance = (key, locale = "en") => {
  if (!stripePromise && key) {
    stripePromise = loadStripe(key, { locale })
  }
  return stripePromise
}
